import script from "./AppBreadcrumbsV3.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBreadcrumbsV3.vue?vue&type=script&setup=true&lang=js"

import "./AppBreadcrumbsV3.vue?vue&type=style&index=0&id=d81a096a&lang=css"

const __exports__ = script;

export default __exports__